import ReducerCreator from '../registerReducer';
import * as TICKETSTATUSES from './ticketStatuses.constants';
import { TicketStatus } from '../../models';
import { StoreItemId } from '../Store';

const r = new ReducerCreator<TicketStatus>()
    .register<void>(TICKETSTATUSES.TICKET_STATUSES_LOAD, (state, payload) => {
        const res = (Object as any).assign({}, state, { isLoading: true, isLoaded: false });
        return res;
    })
    .register<TicketStatus[]>(TICKETSTATUSES.TICKET_STATUSES_LOAD_SUCCESS, (state, payload) => {
        const dictionary = {};
        payload.forEach(status => {
            dictionary[status.id] = status;
        });
        const si = new StoreItemId<TicketStatus>();
        si.isLoading = false;
        si.isLoaded = true;
        si.hasError = false;
        si.error = null;
        si.dictionary = dictionary;
        return si;
    })
    ;

export function ticketStatusesReducer(state: StoreItemId<TicketStatus> = new StoreItemId<TicketStatus>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
